<template>
  <div>
    <h2>Training Reservations</h2>
    <button @click="openCreate">+ Add Reservation</button>

    <table>
      <thead>
        <tr>
          <th>Start</th>
          <th>End</th>
          <th>Project</th>
          <th>Time</th>
          <th>Persons</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="reservation in reservations" :key="reservation.id">
          <td>{{ reservation.start_date }}</td>
          <td>{{ reservation.end_date }}</td>
          <td>{{ reservation.project_type }}</td>
          <td>{{ reservation.start_time }} - {{ reservation.end_time }}</td>
          <td>{{ reservation.number_of_persons }}</td>
          <td>
            <select v-model="reservation.status" @change="changeStatus(reservation)">
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </td>
          <td>
            <button @click="editReservation(reservation)">✏️</button>
            <button @click="deleteReservation(reservation.id)">🗑️</button>
          </td>
        </tr>
      </tbody>
    </table>

    <TrainingReservationForm
      v-if="showForm"
      :reservation="selected"
      @close="closeForm"
      @saved="fetchReservations"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import TrainingReservationForm from './TrainingReservationForm.vue'
import {
  getReservations,
  deleteReservation as apiDeleteReservation,
  updateStatus,
} from '@/services/trainingReservations'

const reservations = ref([])
const showForm = ref(false)
const selected = ref(null)

const fetchReservations = async () => {
  try {
    const res = await getReservations()
    reservations.value = res.data.data
  } catch (error) {
    alert('Erreur lors de la récupération : ' + error.response?.data?.message || error.message)
  }
}

const openCreate = () => {
  selected.value = null
  showForm.value = true
}

const editReservation = (r) => {
  selected.value = r
  showForm.value = true
}

const closeForm = () => {
  showForm.value = false
  fetchReservations()
}

const changeStatus = async (reservation) => {
  await updateStatus(reservation.id, reservation.status)
  fetchReservations()
}

const deleteReservation = async (id) => {
  if (confirm('Are you sure?')) {
    await apiDeleteReservation(id)
    fetchReservations()
  }
}

onMounted(fetchReservations)
</script>
